
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"22","fill":"none","stroke":"#A6A9EB","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 21V11h6v10M1 8l9-7 9 7v11a2 2 0 01-2 2H3a2 2 0 01-2-2V8z"}})])
          )
        }
      }
    